<template>
    <div>
        <b-card no-body class="p-0">
            <div class="dashboard">
                <div class="row m-0">
                    <div class="item bg-gradient-info col-12 col-md-6 p-2">
                        <img src="@/assets/images/lines.svg" class="card-img-absolute" alt="circle-image">
                        <div class="text-center">Limite de investimento</div>
                        <h4 class="mt-2 text-center text-white">{{valorInvestir}}</h4>
                    </div>
                    <div class="item bg-gradient-success col-12 col-md-6 p-2">
                        <img src="@/assets/images/lines.svg" class="card-img-absolute" alt="circle-image">
                        <div class="text-center">Valor total investido</div>
                        <h4 class="mt-2 text-center text-white">{{totalInvestido}}</h4>
                    </div>
                </div>
            </div>
                <b-tabs v-model="indiceTab" card class="p-0 investimentos" justified>
                    <b-tab :title="aba.titulo" v-for="aba,i in abas" :key="aba.titulo" class="p-0">
                        <div class="row pt-3">
                            <div class="col-12 text-red-500 px-3" v-for="debito,i in aba.debitos" :key="`debito${i}`">
                                <span>
                                    {{debito.descricao}} - 
                                </span>
                                <span class="float-right">
                                    {{debito.valor}}
                                </span>
                            </div>

                            <div class="col-12 text-green-500 px-3">
                                <span>
                                    Valor investido - 
                                </span>
                                <span class="float-right">
                                    {{aba.dados.valorAlocado}}
                                </span>
                            </div>

                            <div class="col-12 px-3">
                                <span>
                                    Total restante - 
                                </span>
                                <span class="float-right">
                                    {{projetoIniciado ? aba.dados.restante : aba.dados.valorRestante}} 
                                </span>
                            </div>
                            
                            <div class="col-12"><hr></div>


                            <div class="col-12 col-md-4 text-center" v-if="!projetoIniciado">
                                <b-badge>Total previsto</b-badge>
                                <div>{{aba.dados.totalPrevisto}}</div>
                            </div>
                            <div :class="`col-12 col-md-4 text-center`" v-if="!projetoIniciado">
                                <b-badge>Total restante</b-badge>
                                <div>{{aba.dados.valorRestante}}</div>
                            </div>
                            
                            <div class="col-12 col-md-3 text-center" v-if="projetoIniciado">
                                <b-badge>Total previsto</b-badge>
                                <div>{{aba.dados.totalPrevisto}}</div>
                            </div>
                            <div class="col-12 col-md-3 text-center" v-if="projetoIniciado">
                                <b-badge>Total realizado</b-badge>
                                <div>{{aba.dados.totalCustosRealizado}}</div>
                            </div>
                            <div :class="`col-12 col-md-3 text-center`" v-if="projetoIniciado">
                                <b-badge>Total restante</b-badge>
                                <div>{{aba.dados.restante}}</div>
                            </div>
                            <div class="col-12 col-md-3 text-center" v-if="projetoIniciado">
                                <b-badge :variant="aba.dados.porcentagem > 0 ? 'danger' : 'primary'">Desvio</b-badge>
                                <div :class="`text-${aba.dados.porcentagem > 0 ? 'red' : 'black'}-500`">{{aba.dados.desvio}}/ <span class="h6">{{aba.dados.porcentagem}}%</span></div>
                            </div>
                            <input-money :disabled="!projetoEditavel" v-if="!projetoIniciado" class="col-12 col-md-4" v-model="aba.dados.valorAlocado" label="Valor à investir" :ref="`${i}-valor`"/>

                        </div>
                        <hr>
                        <div class="row p-3" v-if="projetoIniciado">
                            <input-money :disabled="!projetoEditavel" class="col-12 col-md-3" v-model="aba.dados.valorAlocado" label="Valor à investir" :ref="`${i}-valor`"/>
                            <input-textarea class="col-12" :readonly="!projetoEditavel || !aba.dados.liberaJustificativa" label="Justificativa"  v-model="aba.dados.justificativa" :required="aba.dados.liberaJustificativa" :ref="`${i}-justificativa`" />
                            
                        </div>
                        <hr v-if="projetoIniciado">
                    </b-tab>
                </b-tabs>
                <div class="mx-3 mb-3">
                    <b-button variant="success" v-if="permissao.u && projetoEditavel" @click="salvar()">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar
                    </b-button>
                </div>
        </b-card>
    </div>
</template>
<script>

import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import InputMoney from "@/components/inputs/InputMoney.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import {FormMixin} from "@/common/mixins/FormMixin";
import cloneDeep from "lodash/cloneDeep";
export default {
    mixins: [AlertasMixin, FormMixin],
    props :{
        projeto : {
            required : true,
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        InputMoney,
        InputTextarea,
    },
    data : () =>({
        indiceTab : 0,
        buscando : 0,
        abas : [
            { titulo : "RH - Recursos humanos", endpoint : "rh", rubrica : "recurso-humano", dados : [], totais : {}, debitos : [] },
            { titulo : "ST - Serviço terceiro", endpoint : "st", rubrica : "servico-terceiro", dados : [], totais : {}, debitos : [] },
            { titulo : "MC - Material de consumo", endpoint : "mc",  rubrica : "material-consumo", dados : [], totais : {}, debitos : [] },
            { titulo : "VD - Viagens e diárias", endpoint : "vd", rubrica : "viagem-diaria", dados : [], totais : {}, debitos : [] },
            { titulo : "OU - Outros", endpoint : "or", dados : [], rubrica : "outro-recurso", totais : {}, debitos : [] },
            { titulo : "CT - Citenel", endpoint : "c", dados : [], rubrica : "citenel", totais : {}, debitos : [] },
            { titulo : "AC - Auditoria contábil", endpoint : "ac", rubrica : "auditoria-contabil", dados : [], totais : {}, debitos : [] },
        ],
        salvos : -1
    }),
    methods : {
        buscarInvestimentos : function(endpoint){
            this.$store.dispatch(START_LOADING);
            this.buscando = this.abas.filter(el => endpoint ? el.endpoint == endpoint : true).length;
            this.abas.filter(el => endpoint ? el.endpoint == endpoint : true).forEach(element => {
                ProjetoGestaoService.buscarInvestimentos(this.projeto.id, element.endpoint, this.projetoIniciado).then(response => {
                    
                    element.debitos = [];
                    if(!this.projetoIniciado){
                        let res = response.data.data;
                        
                        res.valorAlocado = res.valorAlocado || 0;
    
    
                        res.valorRestante = helpers.formatarValor((res.totalPrevisto || 0) - (res.valorAlocado || 0));
                        res.totalPrevisto = helpers.formatarValor(res.totalPrevisto || 0);
                        res.valorAlocado = helpers.formatarValor(res.valorAlocado || 0);

                        this.buscarDebitos(element.rubrica, res);
                        element.dados = res;    
                    }else{
        
                        let res = response.data.data;
                        
                        res.desvio = res.totalCustosRealizado - (res.totalPrevisto ? res.totalPrevisto : 0);
                        res.porcentagem = parseFloat((res.desvio * 100) / (res.totalPrevisto ? res.totalPrevisto : 0)).toFixed(2);
                        if(res.porcentagem == Infinity){
                            res.porcentagem = 100;
                        }
                        if(res.desvio < 0){
                            res.porcentagem = 0;
                        }
                        res.liberaJustificativa = res.desvio > 0;
                        res.desvio = helpers.formatarValor(res.desvio);

                        res.restante = helpers.formatarValor(res.totalCustosRealizado - (res.valorAlocado || 0));
                        res.valorAlocado = helpers.formatarValor(res.valorAlocado || 0);
                        res.totalPrevisto = res.totalPrevisto ? helpers.formatarValor(res.totalPrevisto) : '-';
                        res.totalCustosRealizado = helpers.formatarValor(res.totalCustosRealizado ? res.totalCustosRealizado : 0);

                        this.buscarDebitos(element.rubrica, res);
                        element.dados = res;
                    }


                }).finally(() => {
                    
                    this.buscando--;
                    if(this.buscando == 0){
                        if(this.salvos == -1)
                        this.$store.dispatch(STOP_LOADING);
                    }
                });                
            });
        },
        salvar : function(){
            this.confirmar("Deseja salvar os investimentos?").then(confirmado => {
                if(!confirmado)
                    return;
                
                let validacao = this.validarFormulario("", true);
                if(!validacao.valido){
                    this.indiceTab = parseInt(validacao.campos[0].substring(0,1));
                    return false;
                }
                
                this.salvos = 0;
                this.$store.dispatch(START_LOADING);
                this.abas.forEach(element => {
                    let form = cloneDeep(element.dados);
                    form.valorAlocado = helpers.removerValor(form.valorAlocado);

                    ProjetoGestaoService.salvarInvestimento(form, element.endpoint, this.projetoIniciado).then(() => {
                        this.salvos++;
                        if(this.salvos == 7){
                            this.alertaSucesso("Investimentos salvos com sucesso!");
                            this.$store.dispatch(START_LOADING);
                            this.salvos = -1;
                        }
                        this.buscarInvestimentos(element.endpoint);
                    }).catch(err => {
                        this.salvos = -1;
                        this.$store.dispatch(STOP_LOADING);
                        if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else{
                            this.alertaErro("Ocorreu um erro ao salvar o investimento!");
                        }                        
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                });
                
            })
        },  
        buscarDebitos : function(rubrica,investimento){
            ProjetoGestaoService.buscarDespesa(
                rubrica,
                investimento.projetoGestaoId || investimento.ProjetoGestaoCooperadaId,
                this.projetoIniciado, 
                investimento.projetoGestaoId ? "ProjetoGestao" : "ProjetoGestaoCooperada",
                investimento.projetoGestaoId ? "ProjetoGestaoId" : "ProjetoGestaoCooperadaId"
            ).then(res => {
                if(rubrica == 'recurso-humano'){
                    this.abas.find(el => el.rubrica == rubrica).debitos = res.data.data.itens[0].equipe.alocacaoHorasIndividuais.map(el => {
                        let totalHoras = el.horasSazonais.reduce((total,hora) => {return total += hora.horas},0)
                        let valorTotal = el.valorHora * totalHoras;
                        return {
                            descricao : `${el.pessoa.nome} (${el.funcao})`,
                            valor : helpers.formatarValor(valorTotal)
                        }
                    });
                }else{
                    this.abas.find(el => el.rubrica == rubrica).debitos = res.data.data.itens.map(el => {
                        return {
                            descricao : helpers.getEnum(el.tipo).text,
                            valor : (!this.projetoIniciado ? helpers.formatarValor(el.valor) : helpers.formatarValor(el.valorIndividual * el.quantidade))
                        }
                    });
                }
            })
        },

        montar : function(){
            this.buscarInvestimentos();
        }
    },
    mounted(){
        //this.buscarInvestimentos();
    },
    computed : {
        projetoIniciado : function(){
            return this.projeto.projetoGestao ? this.projeto.projetoGestao.faseRealizacao : this.projeto.faseRealizacao;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoInvestimento');
        },
        valorInvestir(){
            return helpers.formatarValor((this.projeto.projetoGestao ? this.projeto.projetoGestao.valorInvestir : this.projeto.valorInvestir) || 0);
        },
        totalInvestido : function(){
            return helpers.formatarValor(this.abas.reduce((total,el) => {
                if(!el.dados)
                    return total;
                
                return total + parseFloat(helpers.removerValor(`${el.dados.valorAlocado}`));
            },0));
        }
    }
}
</script>
<style>
    .investimentos .card-header {
        background: #f3f2f2; border-bottom: 1px solid #e5e5e5;
    }

    .investimentos .card-header-tabs{
        align-items: end;
    }
</style>